import {
  BackgroundControlOrder,
  FindAllFrameCompaniesResponse,
} from '@ansvar-sakerhet/api-client';

export function findLatestBackgroundControlOrder(
  company: FindAllFrameCompaniesResponse
): BackgroundControlOrder | undefined {
  return company.BackgroundControlOrder.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )[0];
}
